import { on } from "@/lib/dom/on";
import { showElement } from "@/lib/dom/showElement";
import { hideElement } from "@/lib/dom/hideElement";
import { slideUp } from "@/lib/animate/slideUp";
import "./styles/video.less"
import YouTubePlayer from "./yt-player"
import { addStyle } from "@/lib/dom/addStyle";
import { getSize } from "@/lib/dom/getSize";
import Broweser from "@/lib/browser";
import { useDraggable } from "@/lib/draggable";
import { removeStyle } from "@/lib/dom/removeStyle";
// import { useDraggable } from "@/lib/draggable";

type VideoOptions = {
  height: number;
  width: number;
}

type PlayVideoOptions = {
  videoUrl: string;
  thumbnail: string;
  //是否重新加载播放器
  reloadVideo: boolean;

}

const defaults: VideoOptions = {
  height: 495,
  width: 880,
};


// 播放器对象
let player: YouTubePlayer | undefined = undefined
// 如果节点已存在，那就追加

const html = `<div id="overlay_Video" class="overlay_Video" style="display: none;"></div>
<div id="easyDialogBox_Video" class="easyDialogBox_Video" style="display: none;">
    <div id="easyDialogWrapper_Video" class="easyDialog_wrapper" style="display: block; margin: 0px;">
        <div class="easyDialog_content">
            <h4 class="easyDialog_title" id="easyDialogTitle_Video">
                <a href="javascript:void(0)" title="closeWindows" class="close_btn" id="closeBtn_Video">×</a><span>Product Video</span>
            </h4>
            <div class="easyDialog_text">
                <div style="max-width: 880px; font-size: 15px; width: 100%; margin: auto;">
                    <div id="YouTubePlayContainer" class="video-pic"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;
document.body.insertAdjacentHTML('beforeend', html);
// useDraggable(document.querySelector<HTMLElement>('#easyDialogBox_Video')!, document.querySelector<HTMLElement>('#easyDialogBox_Video .easyDialog_title')!, true)

const closeVideo = () => {
  hideElement('#overlay_Video')
  hideElement('#easyDialogBox_Video')
  player?.pause()
}

//弹层关闭时，暂停播放视频
on('#closeBtn_Video', 'click', () => {
  closeVideo();
})

export const usePlayVideo = (videoWidth: number, videoHeight: number) => {

  const setBackground = (thumbnail: string) => { // 如果有缩略图
    if (thumbnail) {
      const el = document.querySelector<HTMLElement>('.video-pic');
      if (el) {
        addStyle(el, {
          'background-image': `url(${thumbnail})`,
          'background-size': 'contain',
        });
      }
    }
  }
  //设置背景


  const changeDivHeight = () => {
    // const videoEl = document.querySelector<HTMLElement>("#easyDialogBox_Video")!;
    const YouTubePlayContainer = document.querySelector<HTMLIFrameElement>("#YouTubePlayContainer");

    // if ((document.body.clientWidth - 910.00) / 2.00 >= 1) {
    //   // 居中对齐
    //   addStyle(videoEl, 'left', (document.body.clientWidth - 910.00) / 2.00)
    // }
    // else {
    //   addStyle(videoEl, 'left', 0)
    // }
    // // 清空
    // removeStyle(videoEl, 'transform');

    if (YouTubePlayContainer) {
      addStyle(YouTubePlayContainer, {
        'width': '100%',
        'max-width': '880px',
      });

      var size = getSize(YouTubePlayContainer);;
      var videoheight = size.width * videoHeight / videoWidth;
      if (videoheight < 120) {
        videoheight = Broweser.isSmall() ? 201 : 660;
      }
      addStyle(YouTubePlayContainer, {
        'height': videoheight + 'px'
      });
    }
  }
  const openVideoZoom = () => {
    showElement('#easyDialogBox_Video');
    showElement('#overlay_Video');
  }

  const playVideo = (options?: Partial<PlayVideoOptions> | string) => {
    const opts = Object.assign({
      width: videoWidth,
      height: videoHeight,
      videoUrl: '',
      thumbnail: '',
      reloadVideo: false,
    }, typeof (options) == 'string' ? { videoUrl: options } : options)

    setBackground(opts.thumbnail)

    openVideoZoom();
    changeDivHeight();

    // 如果已有播放器，那就直接播放
    if (player) {
      if (opts.reloadVideo) {
        player.load(opts.videoUrl, true, 0)
      } else {
        //播放
        player.play();
      }

    } else {
      player = new YouTubePlayer(document.querySelector('#YouTubePlayContainer')!, opts)
      player.on('ready', () => {
        // changeDivHeight();
      })
      // 如果播放结束，那就停止播放
      player.on('ended', () => {
        player?.stop();
      })
      player.load(opts.videoUrl, true, 0)
    }
  }

  on(window, 'resize', () => {
    changeDivHeight();
  })

  return {
    playVideo,
    closeVideo,
  }
}